import filterConstants from '../constants';

const boardview = () => ({
  id: null,
  name: null,
  type: filterConstants.FILTERS.boardview,
  properties: {
    [filterConstants.PROPERTY.text]: '',
    [filterConstants.PROPERTY.assignee]: '',
    [filterConstants.PROPERTY.status]: '',
    [filterConstants.PROPERTY.priority]: '',
    [filterConstants.PROPERTY.reporter]: '',
    [filterConstants.PROPERTY.rangeDate]: '',
    [filterConstants.PROPERTY.startDate]: '',
    [filterConstants.PROPERTY.endDate]: '',
    [filterConstants.PROPERTY.creationDate]: '',
    [filterConstants.PROPERTY.color]: '',
    [filterConstants.PROPERTY.overdue]: '',
  },
});

export default boardview;
